/** Shared typed split timestamp validation (INV-7). */
const SPLIT_ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/;

/** Invalid row data can be quarantined; programming and invariant failures remain fatal. */
export class SplitRowError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "SplitRowError";
  }
}

/** Explicit offsets make parsing independent of the device timezone. */
export function assertSplitOccurredAt(value: string): void {
  if (!SPLIT_ISO_INSTANT.test(value) || !Number.isFinite(Date.parse(value))) {
    throw new SplitRowError(`Invalid split date: ${value}. Use ISO-8601 with an explicit offset.`);
  }
}

